import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import {
  CompanyPin,
  MonthlyCostCalculationParams,
  MonthlyCostInfo,
} from '../../models';

export const validatePin = createAction(
  '[Calculator] Validate Pin',
  /* eslint-disable-next-line @typescript-eslint/no-unsafe-function-type */
  props<{ payload: CompanyPin; closeMenu?: Function; fromMenu?: boolean }>()
);

export const validatePinSuccess = createAction(
  '[Calculator] Validate Pin Success',
  props<{ fromMenu?: boolean }>()
);

export const validatePinFail = createAction(
  '[Calculator] Validate Pin Fail',
  props<{ error: HttpErrorResponse }>()
);

// Logout actions
export const logout = createAction('[Calculator] Logout');

export const logoutSuccess = createAction('[Calculator] Logout Success');

// Cost calculation actions
export const calculateMonthlyCost = createAction(
  '[Calculator] Calculate Monthly Cost',
  props<{ payload: MonthlyCostCalculationParams }>()
);

export const calculateMonthlyCostSuccess = createAction(
  '[Calculator] Calculate Monthly Cost Success',
  props<{ monthlyCostData: MonthlyCostInfo }>()
);

export const calculateMonthlyCostFail = createAction(
  '[Calculator] Calculate Monthly Cost Fail',
  props<{ error: HttpErrorResponse }>()
);

export const displayError = createAction(
  '[Calculator] Display Error',
  props<{ error: HttpErrorResponse }>()
);

export const navigateToNotEligible = createAction(
  '[Calculator] Navigate to Not Eligible'
);

export const checkAnotherProperty = createAction(
  '[Calculator] Check Another Property'
);
